import NiceModal from '@ebay/nice-modal-react';

import { AddPaymentInstrumentPopupController } from './add-payment-instrument-popup.controller';

export const addPaymentInstrumentPopupModalId = 'add-payment-instrument-popup';
const AddPaymentInstrumentPopupModal = NiceModal.create(AddPaymentInstrumentPopupController);
NiceModal.register(addPaymentInstrumentPopupModalId, AddPaymentInstrumentPopupModal);
